import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import NewsPagination from './NewsPagination/NewsPagination.jsx';
import NewsFilter from './NewsFilter/NewsFilter.jsx';
import NewsItem from './NewsItem/NewsItem.jsx';
import { Spinner } from '../../../../common/index.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';

export function NewsContainer({
  selectedCategories,
  news,
  isLoadingNews,
  isFetchingNews,
  categories,
  currentPaginatorPage,
  onCategoriesChange,
  onPageChange,
  onRefetch = () => undefined,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <NewsFilter
        selectedCategories={selectedCategories}
        onCategoriesChange={onCategoriesChange}
        onClickShowArchive={() => navigate(routes.newsArchive)}
        categories={categories}
        onRefetch={onRefetch}
      />
      <div className={`news-hp-container`}>
        {isLoadingNews || isFetchingNews ? (
          <Spinner />
        ) : (
          <>
            <Row>
              {(news?.data || []).map((itemData) => (
                <NewsItem
                  key={itemData.id}
                  redirectToNewsEdit={(newsId) =>
                    navigate(`${routes.cmsNewsEdit}/${newsId}`, {
                      state: { from: location },
                    })
                  }
                  item={itemData}
                />
              ))}
            </Row>
            <Row>
              {news && (
                <NewsPagination
                  first={news.from}
                  current={currentPaginatorPage || news.current_page}
                  last={news.last_page}
                  onPageChange={onPageChange}
                />
              )}
            </Row>
          </>
        )}
      </div>
    </>
  );
}

export default NewsContainer;

NewsContainer.propTypes = {
  selectedCategories: PropTypes.array,
  news: PropTypes.object,
  isLoadingNews: PropTypes.bool,
  isFetchingNews: PropTypes.bool,
  categories: PropTypes.array,
  fetchingNewsInProgress: PropTypes.bool,
  onCategoriesChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onRefetch: PropTypes.func,
  currentPaginatorPage: PropTypes.number,
};
